<template>
  <div class="adv-form">
    <div v-for="group in groups" :key="group.name">
      <h3
        v-if="group.fields && group.fields.length > 0 && showTitle"
        class="title-box"
      >
        <van-icon name="column" />{{ group.name }}
        <!-- <p v-if="group.description" class="tip">{{group.description}}</p> -->
      </h3>
      <div class="base-box">
        <div
          v-for="(row, rid) in rowLayout(group)"
          :key="rid"
          class="base-item"
        >
          <template v-for="field in row">
            <div
              :key="field.id"
              :class="{ fieldLabelRequired: field.nullable == 0 }"
            >
              <!-- <p v-if="showLabel(field)"></p> -->
              <!-- 单行文本框 -->
              <template v-if="field.editorType == 1">
                <van-field
                  class="input-item"
                  v-model="formData[field.field]"
                  :maxlength="field.fieldLength"
                  :label="field.fieldCaption"
                  :required="field.nullable==0"
                  clearable
                  :placeholder="'请输入' + field.description"
                />
              </template>
              <!-- 日期选择框 -->
              <template v-if="field.editorType == 3">
                <van-cell
                  class="input-item"
                  :title="field.fieldCaption"
                  :value="dateFormatString(formData[field.field])"
                  is-link
                  :required="field.nullable==0"
                  @click="showDatePicker(undefined, field)"
                />
              </template>
              <!-- 单选下拉框 -->
              <template v-if="field.editorType == 4">
                <van-cell
                  class="input-item"
                  :title="field.fieldCaption"
                  :value="getDisplayValue(formData[field.field], field)"
                  is-link
                  :required="field.nullable==0"
                  @click="showPicker(field, undefined)"
                />
              </template>
              <!-- 单选下拉框 -->
              <template v-if="field.editorType == 5">
                <van-cell
                  class="input-item"
                  :title="field.fieldCaption"
                  :value="getDisplayValue(formData[field.field], field)"
                  is-link
                  :required="field.nullable==0"
                  @click="showPicker(field, undefined)"
                />
              </template>
              <!-- 多选下拉框 -->
              <template v-if="field.editorType == 11">
                <van-cell
                  class="input-item"
                  :title="field.fieldCaption"
                  :value="getConcernBranchName(formData[field.field])"
                  is-link
                  :required="field.nullable==0"
                  @click="showConcernBranchPicker(field, formData[field.field])"
                />
              </template>
              <!-- 推荐单位选择框 -->
              <template v-if="field.editorType == 14">
                <van-cell
                  class="input-item"
                  :title="field.fieldCaption"
                  :value="getRecommendBranchName(formData[field.fields[1]])"
                  is-link
                  :required="field.nullable==0"
                  @click="showRecommendBranchPicker(field, undefined)"
                />
              </template>
              <!--复选框 -->
              <template v-if="field.editorType == 13">
                <van-checkbox-group
                  v-model="field.checktion"
                  direction="horizontal"
                  @change="field.changeHandler"
                >
                  <van-checkbox
                    :name="item.value"
                    v-for="(item, index) in fieldOptionsData(field)"
                    :key="index"
                    :value="item.value"
                    >{{ item.name }}</van-checkbox
                  >
                </van-checkbox-group>
              </template>
              <!-- 地区选择框 -->
              <template v-if="field.editorType == 10">
                <van-cell
                  class="input-item"
                  :title="field.fieldCaption"
                  :value="getShengName(formData[field.fields[0]]) + getCityName(formData[field.fields[1]])"
                  is-link
                  :required="field.nullable==0"
                  @click="showAddressPicker(field, undefined)"
                />
              </template>
              <!-- 二级选择框 -->
              <template v-if="field.editorType == 12">
                <van-cell
                  class="input-item"
                  :title="field.fieldCaption"
                  :value="getTitleDisplayValue(formData[field.field], field)"
                  is-link
                  :required="field.nullable==0"
                  @click="showTitlePicker(field, undefined)"
                />
              </template>
              <!-- 大文本输入域 -->
              <template v-if="field.editorType == 7">
                <div class="van-cell__title">
                  <p>{{field.fieldCaption }}</p>
                </div>
                <div>
                  <van-field
                    class="input-item"
                    v-model="formData[field.field]"
                    :maxlength="field.fieldLength"
                    clearable
                    type="textarea"
                    autosize
                    :placeholder="'请输入' + field.description"
                  />
                </div>
              </template>
              <!-- 文件 上传 -->
              <!-- <template v-if="field.editorType == 2">
                            <el-upload
                                :action="uploadUrl"
                                accept="*"
                                :on-remove="field.handlers.onRemove"
                                :on-success="field.handlers.onSuccess"
                                :on-error="field.handlers.onError"
                                :limit="1"
                                :before-upload="field.handlers.beforeUpload"
                                :before-remove="field.handlers.beforeRemove"
                                :on-exceed="field.handlers.onExceed"
                                :multiple="false"
                                :file-list="field.fileList"
                                list-type="text"
                                style=" width:95%"
                                >
                                <el-button v-if="field.showUploadBtn && field.readonly == 0" type="primary" style="margin-top:23px">选择文件</el-button>
                                <div slot="tip" class="el-upload__tip"></div>
                            </el-upload>
                        </template> -->
              <!-- 图片 上传 -->
              <template v-if="field.editorType == 6">
                <div class="van-cell__title" style="position: relative;">
                  <p>{{field.fieldCaption}}</p>
                </div>
                <template>
                  <div style="padding:30px 20px 10px 20px">
                    <van-uploader
                      v-model="field.fileList"
                      accept="image/*"
                      :after-read="field.handlers.beforeUpload"
                      @delete="field.handlers.delFile"
                      :max-count="1"
                    >
                    </van-uploader>
                  </div>
                  <!-- <img :src="field.imgUrl"> -->
                </template>
                <!-- <el-upload
                                :action="uploadUrl"
                                accept="*"
                                :on-remove="field.handlers.onRemove"
                                :on-success="field.handlers.onSuccess"
                                :on-error="field.handlers.onError"
                                :limit="1"
                                :class="{noExtraPicCard:!field.showUploadBtn}"
                                :before-upload="field.handlers.beforeUpload"
                                :before-remove="field.handlers.beforeRemove"
                                :on-exceed="field.handlers.onExceed"
                                :on-preview="field.handlers.onPreview"
                                :multiple="false"
                                :file-list="field.fileList"
                                list-type="picture-card"
                                style=" width:95%"
                                >
                                <el-button v-if="field.showUploadBtn && field.readonly == 0" type="primary" style="margin-top:23px">选择文件</el-button>
                                <div slot="tip" class="el-upload__tip"></div>
                            </el-upload> -->
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog> -->
    <!-- 选择弹窗 -->
    <van-popup
      v-model="selectModel"
      position="bottom"
      :style="{ 'min-height': '20%' }"
    >
      <van-datetime-picker
        v-if="dateField"
        :value="dateField.value"
        type="date"
        :min-date="minDate"
        @cancel="onCancel"
        @confirm="onConfirmDate"
      />
      <van-picker
        v-else
        show-toolbar
        ref="picker"
        :value-key="key"
        :columns="columns"
        @change="onChange"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>

    <!-- 下拉多选弹窗 -->
    <van-popup
      v-model="selectBranchModel"
      position="bottom"
      :style="{ 'min-height': '20%' }"
      class="inputSelect"
    >
      <div class="selectDiv">
        <div class="btn_left" @click="selectCancel()">取消</div>
        <div class="btn_true" @click="selectChecked()">确定</div>
      </div>
      <van-checkbox-group v-model="selection" direction="horizontal">
        <van-checkbox
          :name="item.value"
          v-for="(item, index) in this.customDataList['concernUnitId']"
          :key="index"
          :value="item.code"
          >{{ item.name }}</van-checkbox
        >
      </van-checkbox-group>
    </van-popup>
  </div>
</template>

<script>
import {
  // getCommonDictionary,
  getSchemaDetails,
  getPZUrl,
} from "@/api/dictionary";
import { uploadFile, delFile } from "@/api/upload";
import Exif from "exif-js";
import {
  Field,
  Button,
  Picker,
  DatetimePicker,
  Popup,
  TreeSelect,
  Area,
  Toast,
  Cell,
  CellGroup,
  Notify,
  NavBar,
  Icon,
  Checkbox,
  CheckboxGroup,
  Uploader,
} from "vant";
export default {
  props: {
    labelSize: {
      type: Number,
      default: 33,
    },
    labelSameRow: {
      type: Boolean,
      default: false,
    },
    lineHeight: {
      type: Number,
      default: 46,
    },
    colCount: {
      type: Number,
      default: 1,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    // showLabel: {
    //     type: Boolean,
    //     default: true
    // },
    initFields: {
      type: Array,
      default: () => [],
    },
    // 可以指定batchType和businessType，组件将自动获取fields（字段列表）信息
    batchType: {
      type: Number,
    },
    // 可以指定batchType和businessType，组件将自动获取fields（字段列表）信息
    businessType: {
      type: Number,
    },
    // 自定义数据源，针对各种需要数据源的控件(单/多选下拉框、radiobutton组、树形下拉框等)，有可能需要通过特殊接口获取数据源
    // 属性值示例：
    // {
    //     data1: [{name: 'name1'}],
    // }
    customDataList: {
      type: Object,
      default: () => {},
    },
    allDictionary: {
      type: Array,
      default: () => [],
    },
    allAddress: {
      type: Array,
      default: () => [],
    },
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      files: {
        name: "",
        type: "",
      },
      formFields: [],
      // uploadUrl: uploadURL,
      editorWidthWeights: [33.3, 50, 66, 100, 200, 300],
      cascaderOptions: {},
      dialogImageUrl: "",
      dialogVisible: false,
      selectModel: false,
      selectKey: "", //所选择的字段
      key: "name", //选择弹窗显示对应的参数名
      columns: [],

      pickerField: undefined, // 弹窗选择对应的字段
      dateField: undefined, // 弹窗日期选择的字段,
      selection: [],
      selectBranchModel: false,
      titleColumns1: [
        {
          name: "高等学校教师",
          value: 1,
          children: [
            { name: "教授", value: 11 },
            { name: "副教授", value: 12 },
            { name: "讲师", value: 13 },
            { name: "助理讲师", value: 14 },
          ],
        },
        {
          name: "中等专业学校教师",
          value: 2,
          children: [
            { name: "正高级讲师", value: 21 },
            { name: "高级讲师", value: 22 },
            { name: "讲师", value: 23 },
            { name: "助理讲师、教员", value: 24 },
          ],
        },
        {
          name: "中小学教师",
          value: 3,
          children: [
            { name: "正高级教师", value: 31 },
            { name: "高级讲师", value: 32 },
            { name: "一级教师", value: 33 },
            { name: "二级教师、三级教师", value: 34 },
          ],
        },
        {
          name: "自然科学、社会科学研究人员",
          value: 4,
          children: [
            { name: "研究员", value: 41 },
            { name: "副研究员", value: 42 },
            { name: "助理研究员", value: 43 },
            { name: "研究实习员", value: 44 },
          ],
        },
        {
          name: "工程技术人员",
          value: 5,
          children: [
            { name: "正高级工程师", value: 51 },
            { name: "高级工程师", value: 52 },
            { name: "工程师", value: 53 },
            { name: "助理工程师", value: 54 },
          ],
        },
        {
          name: "实验技术人员",
          value: 6,
          children: [
            { name: "正高级实验师", value: 61 },
            { name: "高级实验师", value: 62 },
            { name: "实验师", value: 63 },
            { name: "助理实验师", value: 64 },
          ],
        },
        { name: "其他", value: 7, children: [] },
        { name: "无", value: 8, children: [] },
      ],
    };
  },

  watch: {
    initFields: function(newVal) {
      this.formFields = newVal;
    },
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [TreeSelect.name]: TreeSelect,
    [Area.name]: Area,
    [Toast.name]: Toast,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Notify.name]: Notify,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Uploader.name]: Uploader,
  },
  computed: {
    fields() {
      return this.formFields;
    },
    formFieldValue() {
      return (field) => this.formData[field.field];
    },
    minDate() {
      return new Date("1960");
    },
    showLabel() {
      // 文本框、多选Radio 时，在第一行显示Label
      return (field) => [1, 13].indexOf(field.editorType) >= 0;
    },
    groups() {
      let map = {};
      this.fields
        .filter((itm) => itm.editorType == 9)
        .sort((a, b) => a.seq - b.seq)
        .flatMap((itm) => {
          map[itm.editorGroup] = {
            name: itm.fieldCaption,
            description: itm.description,
            fields: [],
          };
        });
      return this.fields.reduce((acc, cur) => {
        if (cur.editorType != 9 && acc[cur.editorGroup]) {
          acc[cur.editorGroup].fields.push(cur);
        }
        return acc;
      }, map);
    },
    rowLayout() {
      return (group) => {
        let fields = group.fields.sort((a, b) => a.seq - b.seq);
        let rows = [];
        // let weight = 0;
        for (var i = 0; i < fields.length; i++) {
          if (!fields[i].display) {
            continue;
          }
          rows.push([fields[i]]);
          this.prepareField(fields[i], this.formData);
        }
        return rows;
      };
    },
    widthOfRowEnd() {
      return (group) => {
        let rowWeight = 0;
        group.fields.forEach((f) => (rowWeight += f.widthWeight));
        return 100 - rowWeight;
      };
    },
    widthOfLabel() {
      return (field) =>
        this.labelSameRow
          ? field.editorWidth <= 4
            ? "{0}%".format(this.labelSize)
            : "{0}%".format(
                (this.labelSize * 100) / this.fieldWidth(field) / this.colCount
              )
          : "90%";
    },
    widthOfControl() {
      return (field) => {
        if (this.labelSameRow) {
          return "{0}%".format(
            100 - Number.parseInt(this.widthOfLabel(field).replace("%", ""))
          );
        } else {
          return "100%";
        }
      };
    },
    heightOfLabel() {
      return this.labelSameRow ? 46 + "px" : "unset";
    },
    heightOfControl() {
      return this.lineHeight + "px";
    },
    fieldDictionary() {
      return (code) =>
        code ? this.allDictionary.filter((item) => item.dictCode == code) : [];
    },
    fieldCascader() {
      return (field) =>
        this.cascaderOptions[field] ? this.cascaderOptions[field] : [];
    },
    fieldOptionsData() {
      return (field) => {
        if (this.customDataList && this.customDataList[field.field]) {
          return this.customDataList[field.field];
          // if (Array.isArray(data)) {
          //     return data;
          // } else if (typeof data == 'function') {
          //     return data(field);
          // } else {
          //     return [data];
          // }
        }

        if (field.dictionaryId) {
          return field.editorType == 12
            ? this.fieldCascader(field.dictionaryId)
            : this.fieldDictionary(field.dictionaryId);
        }
        return [];
      };
    },
    fieldValue() {
      return (field) => this.formData[field] || "";
    },
    fieldWidth() {
      return (field) => {
        let weight =
          this.editorWidthWeights[field.editorWidth - 1] / this.colCount;
        if (weight > 100) weight = 100;
        if (weight < 33) weight = 33.3;
        return weight;
      };
    },
    province() {
      return (provinceValue) =>
        this.allAddress.filter((item) => item.value === provinceValue).pop();
    },
    sheng() {
      return this.allAddress.filter((item) => item.level === 1);
    },
    shi() {
      return (sheng) => {
        let province = this.province(sheng);
        return province
          ? this.allAddress.filter((item) => item.parentId === province.id)
          : [];
      };
    },
    shi1() {
      return this.allAddress.filter((item) => {
        return item.parentId === this.sheng[0].id;
      });
    },
  },
  methods: {
    onFormDataChanged(data) {
      Object.assign(this.formData, data);
      this.fields.forEach((field) => {
        field.updateValue && field.updateValue(data[field.field]);
      });
    },
    validateForm() {
      let errFields = [];
      let _this = this;
      this.fields
        .sort((a, b) => a.seq - b.seq)
        .forEach(function(field) {
          if (field.nullable == 1 || !field.field) {
            return;
          }
          if (field.fields) {
            if (field.fields.some((f) => !_this.fieldValue(f))) {
              errFields.push(field);
              return false;
            }
          } else if (!_this.fieldValue(field.field)) {
            errFields.push(field);
            return false;
          }
        });
      let errField = errFields && errFields[0];
      if (errField) {
        if (errField.editorType == 6 || errField.editorType == 2) {
          Toast.fail("请上传" + errField.fieldCaption);
        } else {
          if (errField.editorType != 5) {
            // _this.$refs[errField.field][0].focus();
          }
          Toast.fail(errField.fieldCaption + "不能为空！");
        }
        return false;
      }
      return true;
    },
    dateFormatString(value) {
      let date = new Date(value);
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      return date.getFullYear() + "-" + m + "-" + d;
    },
    prepareField(field, data) {
      if (field.prepared) {
        return;
      }
      this.$set(field, "value", null);
      this.$set(field, "rules", []);
      if (field.nullable == 0) {
        field.rules.push({
          required: true,
          message: "请输入" + field.fieldCaption,
          trigger: "blur",
        });
      }
      // 文件上传组件
      if (field.editorType == 6 || field.editorType == 2) {
        this.$set(field, "fileList", []);
        field.handlers = {
          // onRemove: (file, fileList) => this.onFileRemove(field, file, fileList),
          // onSuccess: (resp, file, fileList) => this.onFileSuccess(field, resp, file, fileList),
          // onError: (err, file, fileList) => this.onFileError(field, err, file, fileList),
          // onExceed: (files, fileList) => this.onFileExceed(field, files, fileList),
          beforeUpload: (file) => this.beforeFileUpload(field, file),

          delFile: (file) => this.delFile(field, file),
          // beforeRemove: (file, fileList) => this.beforeFileRemove(field, file, fileList),
          // onPreview: (file) => { this.dialogImageUrl = file.url; this.dialogVisible = true; }
        };

        getPZUrl({ id: this.formData[field.field] }).then((res) => {
          if (res.success) {
            if (res.result) {
              this.$set(field, "imgUrl", res.result);
              field.fileList.push({ content: res.result });
            } else {
              //  this.fileList = [];
            }
          }
        });
        // console.log(this.formData)

        //  var data ={}
        //          Object.assign(this.formData, data);
        // //   data = this.formData
        //   this.$set(data, field.field, this.formData);
        //  console.log(data)
        // this.$set(field, "fileList", []);
        // this.$set(field, "showUploadBtn", field.readonly == 1 ? false : true);
        // field.updateValue = v => {
        //     field.fileList = [];
        //      if (v)
        //         field.showUploadBtn = false;
        //     v && getBase64({id: v}).then(resp => {
        //         if (resp.success) {
        //             field.fileList.push({
        //                 url: resp.result,
        //                 name: ""
        //             });
        //         }
        //     });
        // };
      }
      // 日期选择
      else if (field.editorType == 3) {
        //field.value = this.formData[field.field];
      }
      // 单选
      else if (field.editorType == 4) {
        this.$set(field, "displayValue", null);
        var optionsData = this.fieldOptionsData(field) || [];
        field.updateValue = (v) => {
          var currentItem = optionsData.find((item) => item.value === v);
          field.value = v;
          field.displayValue = currentItem ? currentItem.name : "";
        };
      } else if (field.editorType == 5) {
        // this.$set(field, "displayValue", null);
        // var optionsData = this.fieldOptionsData(field) || [];
        // field.updateValue = v => {
        //     var currentItem = optionsData.find(item => item.value === v);
        //     field.value = v;
        //     console.log(currentItem)
        //     field.displayValue = currentItem ? currentItem.name : "";
        // }
      }
      // 地址组件
      else if (field.editorType == 10) {
        field.fields = field.field.split(",");
        field.changeHandler = (newVal) => {
          this.$set(this.formData, field.fields[1], "");
        };
      }
      // 多选下拉框
      else if (field.editorType == 11) {
        this.$set(field, "selection", []);
        //this.$set(field, "displayValue", null);
        // console.log(field)
        //              console.log(this.customDataList[field.field])
        var optionsData = this.fieldOptionsData(field) || [];
        //  console.log(optionsData)
        field.updateValue = (v) => {
          var currentItem = optionsData.find((item) => item.value === v);
          field.value = v;
          field.displayValue = currentItem ? currentItem.name : "";
        };
        // this.$set(field, "selection", []);
        // field.updateValue = v => {
        //     field.selection = v ? ("" + v).split(",").map(i => i) : [];
        // }
        // field.changeHandler = val => this.$set(this.formData, field.field, val.join(","));
      }
      // 树形下拉列表选择
      else if (field.editorType == 12) {
        // field.changeHandler = val => this.$set(this.formData, field.field, val[val.length - 1]);
        // getCommonDictionary(field.dictionaryId).then(resp => {
        //     if (resp.success) {
        //         this.cascaderOptions[field.dictionaryId] = resp.result;
        //     }
        // });
      } else if (field.editorType == 13) {
        this.$set(field, "checktion", []);
        field.updateValue = (v) => {
          field.checktion = v
            ? ("" + v).split(",").map((i) => Number.parseInt(i))
            : [];
        };
        field.changeHandler = (val) =>
          this.$set(this.formData, field.field, val.join(","));
      } else if (field.editorType == 14) {
        field.fields = field.field.split(",");
      }

      field.updateValue && field.updateValue(this.formFieldValue(field));
      field.prepared = true;
    },
    getTitleName(value) {
      // console.log(value)
      // var optionsData = this.fieldDictionary("TITLE");
      // console.log(optionsData)
    },
    beforeFileUpload(field, file) {
      console.log(file);
      let handleResult = true;
      this.files.name = file.file.name; // 获取文件名
      this.files.type = file.file.type; // 获取类型
      this.imgPreview(field, file.file);
      return handleResult;
    },

    // 处理图片
    imgPreview(field, file) {
      let self = this;
      let Orientation;
      //   去获取拍照时的信息，解决拍出来的照片旋转问题   npm install exif-js --save   这里需要安装一下包
      Exif.getData(file, function() {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function() {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于500K,是就直接上传，反之压缩图片
          if (this.result.length <= 500 * 1024) {
            // 上传图片
            self.afterPortraitFile(field, this.result);
          } else {
            img.onload = function() {
              let data = self.compress(img, Orientation);
              console.log(data);
              // 上传图片
              self.afterPortraitFile(field, data);
            };
          }
        };
      }
    },
    // 压缩图片
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      // let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        // console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //    铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3: //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.3);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    // 旋转图片
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    //将base64转换为文件
    dataURLtoFile(dataurl) {
      console.log(dataurl);
      var arr = dataurl.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], this.files.name, {
        type: this.files.type,
      });
    },

    delFile(field, file) {
      let handleResult = true;
      let id = this.formData[field.field];
      if (id) {
        let params = {
          id,
        };
        delFile(params).then((res) => {
          if (res.success) {
            Toast("删除成功");
            this.formData[field.field] = "";
          } else {
            Toast("删除失败");
          }
        });
      }

      return handleResult;
    },
    afterPortraitFile(field, base64) {
      let params = new FormData();
      let file = this.dataURLtoFile(base64);
      console.log(file);
      params.append("file", file);
      uploadFile(params).then((res) => {
        if (res.success) {
          this.$set(this.formData, field.field, res.result.id);
          Toast("上传成功");
        } else {
          Toast("上传失败");
        }
      });
    },
    getShengName(value) {
      let obj = this.sheng.find((item) => item.value === value);
      if (obj) {
        return obj.name;
      } else {
        return "";
      }
    },
    getCityName(value) {
      let obj = this.allAddress.find((item) => item.value === value);
      if (obj) {
        return obj.name;
      } else {
        return "";
      }
    },
    getConcernBranchName(value) {
      let name = "";
      let arr = value ? ("" + value).split(",").map((i) => i) : [];
      if (arr.length > 0 && this.customDataList["concernUnitId"]) {
        for (let i = 0; i < arr.length; i++) {
          let obj = this.customDataList["concernUnitId"].find(
            (item) => item.code === arr[i]
          );
          if (obj) {
            name = name + obj.name + ",";
          } else {
            name = name + "";
          }
        }
      }
      return name;
    },
    getRecommendBranchName(value) {
      let name = "";
      if (value && this.customDataList["recommendUnitId"]) {
        let obj = this.customDataList["recommendUnitId"].find(
          (item) => item.code === value
        );
        if (obj) {
          return obj.name;
        } else {
          return "";
        }
      }
      return name;
    },
    getDisplayValue(value, field) {
      var optionsData = this.fieldOptionsData(field) || [];
      var currentItem = optionsData.find((item) => item.value === value);
      return currentItem ? currentItem.name : "";
    },
    getTitleDisplayValue(value, field) {
      var optionsData = this.fieldDictionary(field.dictionaryId);
      var currentItem = optionsData.find((item) => item.value === value);
      return currentItem ? currentItem.name : "";
    },
    selectChecked() {
      this.formData["concernUnit"] = this.selection;
      let a = this.selection.join(",");
      this.formData["concernUnitId"] = a;
      this.selectBranchModel = false;
    },
    selectCancel() {
      this.selectBranchModel = false;
    },
    onChange(picker, values, index) {
      if (this.selectKey === "title") {
        picker.setColumnValues(1, values[0].children);
      } else if (this.selectKey === "jg" || this.selectKey === "province") {
        let city = this.allAddress.filter((item) => {
          return item.parentId === values[0].id;
        });
        if (index === 0) {
          picker.setColumnValues(1, city);
        }
      }
    },
    onConfirm(item) {
      this.selectModel = false;
      var fieldVal;
      if (this.selectKey === "concernUnitId") {
        this.formData[this.pickerField.field] = fieldVal = item.code;
      } else if (this.selectKey === "recommendUnitId") {
        this.formData["recommendUnitId"] = item.code;
        this.formData["recommendUnitIdParent"] = item.branchType;
      } else if (this.selectKey === "province") {
        this.formData.province = item[0].value;
        this.formData.city = item[1] ? item[1].value : "";
      } else if (this.selectKey === "title") {
        if (item[0].value == 7 || item[0].value == 8) {
          this.formData.title = item[0].value;
        } else {
          this.formData.title = item[1].value;
        }
      } else {
        this.formData[this.pickerField.field] = fieldVal = item.value;
      }
      this.pickerField.value = fieldVal;
      this.pickerField.displayValue = item.name;
      this.pickerField = undefined;
      this.dateField = undefined;
      this.selectKey = undefined;
    },
    showPicker(pickerField, dateField) {
      this.pickerField = pickerField;
      this.dateField = dateField;
      this.columns = this.fieldOptionsData(pickerField);
      this.selectModel = true;
    },
    showTitlePicker(pickerField, dateField) {
      this.pickerField = pickerField;
      this.dateField = dateField;
      this.selectKey = "title";
      this.columns = [
        {
          values: this.titleColumns1,
          className: "column1",
        },
        {
          values: this.titleColumns1[0].children,
          className: "column2",
        },
      ];
      this.selectModel = true;
    },
    showConcernBranchPicker(pickerField, dateField) {
      this.selectBranchModel = true;
      let arr = dateField ? ("" + dateField).split(",").map((i) => i) : [];
      this.selection = arr;
      this.pickerField = pickerField;
    },
    showRecommendBranchPicker(pickerField, dateField) {
      this.selectModel = true;
      this.selectKey = "recommendUnitId";
      this.columns = this.customDataList["recommendUnitId"];
      this.pickerField = pickerField;
    },
    showDatePicker(pickerField, dateField) {
      this.pickerField = pickerField;
      this.dateField = dateField;
      this.selectModel = true;
    },
    showAddressPicker(pickerField, dateField) {
      this.pickerField = pickerField;
      this.columns = [
        {
          values: this.sheng,
          className: "column1",
        },
        {
          values: this.shi1,
          className: "column2",
        },
      ];
      this.selectKey = "province";
      this.selectModel = true;
    },
    onCancel() {
      this.selectModel = false;
    },
    onConfirmDate(time) {
      this.dateField.value = time;
      //this.formData[this.dateField.field] = time;
      this.formData[this.dateField.field] = this.dateFormatString(time);
      this.selectModel = false;
    },
    deleteError(event) {
      if (event.target.value) {
        event.target.classList.remove("error");
      }
    },
  },
  mounted() {
    if (
      !this.initFields ||
      (this.initFields.length == 0 && this.batchType && this.businessType)
    ) {
      getSchemaDetails({ batchType: 5, businessType: 16 })
        .then((resp) => {
          this.formFields = resp.result;
        })
        .catch(() => {
          this.$message.error(
            "获取表单字段信息失败，batchType={0}, businessType={1}".format(
              this.batchType,
              this.businessType
            )
          );
        });
    } else {
      this.formFields = this.initFields;
    }
  },
};
</script>

<style lang="less">
.adv-form {
  h3 {
    display: flex;
    margin-top: 25px;
    font-size: 16px;
    align-items: center;
    color: #228ccd;
    i {
      margin-right: 6px;
    }
  }
  h4 {
    font-size: 14px;
    line-height: 2;
    span {
      display: inline-block;
      margin-left: 10px;
      color: #d64a4a;
    }
  }
  .base-box {
    width: 100%;
    h3 {
      color: #228ccd;
      margin-left: 15px;
    }
    .van-cell {
      padding: 15px 0;
    }
    .van-cell--required::before{
      display: none;
    }
    .van-cell--required .van-cell__title::after{
      position: absolute;
      color: #ee0a24;
      font-size: 0.37333rem;
      content: '\00A0*';
    }
    .van-cell__value{ overflow:hidden; white-space: nowrap; text-overflow: ellipsis;}
    /deep/.van-nav-bar {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 99;
    }
  }
  .base-item {
    margin-top: 10px;
    .fieldLabelRequired {
      position: relative;
    }
    .fieldLabelRequired p::after {
      position: absolute;
      color: #ee0a24;
      font-size: 0.4rem;
      content: "\00A0*";
    }
    p {
      font-size: 0.4rem;
      color: #333;
      margin-top: 0.8rem;
    }
    /deep/.van-checkbox {
      min-width: 25%;
      margin-top: 15px;
    }
    /deep/div.van-checkbox-group {
      margin-left: 20px;
      margin-top: 15px;
    }
  }
  .base-label {
    float: left;
    width: 100% !important;
    text-align: left;
    height: 26px;
  }
  .input-item {
        border-bottom: 0.02667rem solid #ebedf0;
  }
  .tip {
    color: red;
    vertical-align: middle;
    // line-height: 20px;
  }
  .base-content {
    float: left;
    min-width: 200px;
    text-align: left;
    .el-date-editor {
      width: 96% !important;
    }
    .el-select {
      width: 95% !important;
    }
  }
  .line {
    text-align: center;
    vertical-align: middle;
  }
  .warm {
    font-size: 14px;
    color: #d64a4a;
  }
  .el-date-editor .el-input__inner {
    cursor: pointer;
  }
  .el-form-item {
    margin-bottom: 0.5em;
  }
  div.noExtraPicCard .el-upload--picture-card {
    display: none;
  }
}
.inputSelect /deep/.van-checkbox {
  width: 90%;
  padding: 0.5rem 10%;
  border-bottom: 0.02667rem solid #ebedf0;
}
.inputSelect {
  max-height: 50%;
}
.btn_left {
  width: 60px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  left: 10px;
  font-size: 14px;
  top: 10px;
  float: left;
}
.btn_true {
  width: 60px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  right: 10px;
  font-size: 14px;
  top: 10px;
  float: right;
}
.selectDiv {
  width: 100%;
  height: 30px;
  padding:14px 0 10px 0
}
</style>
